import { render, staticRenderFns } from "./carry-in-detail-report.vue?vue&type=template&id=31bf3ea6"
import script from "./carry-in-detail-report.vue?vue&type=script&lang=js"
export * from "./carry-in-detail-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports